import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes";
import { Fragment } from "react/jsx-runtime";
import Toast from "./components/Toast/Toast";
import { Provider, useSelector } from "react-redux";
import { RootState, store } from "./store";
import StartUp from "./components/StartUp/StartUp";
import { useInactivityTimer } from "./hooks/useInactivityTimer";

function AppContent() {
  return (
    <Fragment>
      <Router>
        <InactivityWrapper>
          <AppRoutes />
        </InactivityWrapper>
      </Router>
      <Toast />
    </Fragment>
  );
}

function InactivityWrapper({ children }: { children: React.ReactNode }) {
  useInactivityTimer();
  return <>{children}</>;
}

function App() {
  return (
    <Provider store={store}>
      <StartUp>
        <AppContent />
      </StartUp>
    </Provider>
  );
}

export default App;
